import { ColumnSortingDirective } from './../_directives/column-sorting.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MoveNextInputDirective } from './move-next-input.directive';
import { CheckValidityDirective } from './check-validity.directive';
import { DoctorNamesSelectorComponent } from '@components/doctor-names-selector/doctor-names-selector.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PageHeaderSearchComponent } from '@components/page-header-search/page-header-search.component';
import { FileControlValueAccessorDirective } from '../_directives/file-control-value-accessor.directive';
import { PageHeaderSelectionsComponent } from '@components/page-header-selections/page-header-selections.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MinValidatorDirective } from './min-validator.directive';
import { TableComponent } from '@components/table/table.component';
import { RemoveSpacesPipe } from '../pipe/remove-spaces.pipe';
import { RemoveSpecialCharactersPipe } from '../pipe/remove-special-characters.pipe';
import { DoctorSpecialtyComponent } from '@components/psp/doctor-specialty/doctor-specialty.component';
import { TooltipModule } from 'primeng/tooltip';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxDatatableModule,
    TooltipModule 
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    CheckValidityDirective,
    ColumnSortingDirective,
    DoctorNamesSelectorComponent,
    MinValidatorDirective,
    FileControlValueAccessorDirective,
    PageHeaderSelectionsComponent,
    NgxDatatableModule,
    PageHeaderSearchComponent,
    TableComponent,
    RemoveSpacesPipe,
    RemoveSpecialCharactersPipe,
    NgSelectModule,
    DoctorSpecialtyComponent,
    TooltipModule
  ],
  declarations: [
    MoveNextInputDirective,
    CheckValidityDirective,
    ColumnSortingDirective,
    DoctorNamesSelectorComponent,
    MinValidatorDirective,
    FileControlValueAccessorDirective,
    PageHeaderSelectionsComponent,
    PageHeaderSearchComponent,
    TableComponent,
    RemoveSpacesPipe,
    RemoveSpecialCharactersPipe,
    DoctorSpecialtyComponent
  ],
})
export class SharedModule { }
